<template>
  <section class="scenes sec">
    <div class="page">
      <SectionHeading
        eyebrow="Scenarios"
        title="已在跑的真实场景"
        desc="不管是提升产值、降低能耗，还是打通数据，先看业务目标，再决定用什么技术。"
      />

      <div class="scene-grid">
        <router-link
          v-for="(s, i) in scenes"
          :key="s.title"
          :to="linePath(s.line)"
          class="scene-item reveal"
          v-reveal="{ delay: i * 70 }"
        >
          <span class="scene-bar"></span>
          <div class="scene-head">
            <h3>{{ s.title }}</h3>
            <IconSvg name="arrow-right"/>
          </div>
          <p>{{ s.desc }}</p>
          <span class="scene-line">{{ lineName(s.line) }}</span>
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import SectionHeading from '@/components/common/SectionHeading'
import IconSvg from '@/components/common/IconSvg'
import { homeScenes, getLine } from '@/data/site'

export default {
  name: 'ScenesSection',
  components: { SectionHeading, IconSvg },
  data() {
    return { scenes: homeScenes }
  },
  methods: {
    linePath(key) {
      const l = getLine(key)
      return l ? l.path : '/home'
    },
    lineName(key) {
      const l = getLine(key)
      return l ? l.name : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.scenes { position: relative; }

.scene-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 18px;
}

.scene-item {
  position: relative;
  padding: 28px 26px 30px;
  border-radius: 16px;
  border: 1px solid var(--line);
  background: linear-gradient(150deg, rgba(11, 23, 48, 0.72), rgba(5, 12, 27, 0.6));
  overflow: hidden;
  transition: transform 0.45s, border-color 0.45s, background 0.45s;

  .scene-bar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background: var(--grad-main);
    transform: scaleY(0.2);
    transform-origin: top;
    transition: transform 0.5s;
  }

  .scene-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;

    h3 { font-size: 18px; color: #fff; }
    svg { width: 18px; height: 18px; color: var(--txt-3); transition: transform 0.4s, color 0.4s; }
  }

  p {
    margin-top: 12px;
    font-size: 14px;
    line-height: 1.85;
    color: var(--txt-3);
  }

  .scene-line {
    display: inline-block;
    margin-top: 18px;
    font-size: 12px;
    letter-spacing: 0.16em;
    color: var(--cyan);
    opacity: 0.75;
  }

  &:hover {
    transform: translateY(-6px);
    border-color: var(--line-strong);
    background: linear-gradient(150deg, rgba(16, 33, 66, 0.85), rgba(7, 15, 33, 0.75));

    .scene-bar { transform: scaleY(1); }
    svg { color: var(--cyan); transform: translateX(4px); }
  }
}

@media (max-width: 1080px) {
  .scene-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}
@media (max-width: 700px) {
  .scene-grid { grid-template-columns: minmax(0, 1fr); gap: 14px; }
  .scene-item { padding: 22px 20px 24px; }
}
</style>
